<template>
	<div v-if="visible" class="modal-overlay">
		<div class="modal">
			<h3>{{ $t("panels.unsavedChanges.title") }}</h3>
			<p>{{ $t("panels.unsavedChanges.message") }}</p>
			<div style="display: flex; flex-direction: row-reverse; gap: 8px; margin-top: 12px">
				<button @click="$emit('discardChanges')" class="blexon-button">{{ $t("panels.unsavedChanges.discardButton") }}</button>
				<button @click="$emit('close')">{{ $t("panels.unsavedChanges.cancelButton") }}</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useMainStore } from "@/store/mainStore";

defineProps({
	visible: Boolean,
});

const store = useMainStore();

const emit = defineEmits(["close", "discardChanges"]);
</script>
